export default "__VITE_ASSET__Ba9INwoh__"